import { ReactNode } from 'react';

import {
  Calendar,
  Drama,
  Eye,
  FileText,
  Files,
  MapPin,
  RefreshCw,
  ArrowRightLeft,
  ArrowUpDown,
  FileCheck,
  FileX,
} from 'lucide-react';
import { LucideIcon } from 'lucide-react';

import {
  InconsistencySource,
  InconsistencyType,
} from '../../../../../../../backend/src/case/inconsistency/inconsistency-display';

interface IconConfig {
  Icon: LucideIcon | (() => ReactNode);
  className: string;
}

export const InconsistencySourceIcons: Record<InconsistencySource, IconConfig> = {
  [InconsistencySource.MultipleDepositions]: {
    Icon: () => (
      <div className="relative">
        <Files className="h-12 w-12 text-purple-500" />
        <ArrowRightLeft className="absolute -right-1 -bottom-1 h-6 w-6 rounded-full bg-purple-100 p-1 text-purple-600" />
      </div>
    ),
    className: 'bg-purple-100',
  },
  [InconsistencySource.SameDeposition]: {
    Icon: () => (
      <div className="relative">
        <FileText className="h-12 w-12 text-blue-500" />
        <ArrowUpDown className="absolute -right-1 -bottom-1 h-6 w-6 rounded-full bg-blue-100 p-1 text-blue-600" />
      </div>
    ),
    className: 'bg-blue-100',
  },
  [InconsistencySource.DepositionVsEvidence]: {
    Icon: () => (
      <div className="relative">
        <FileText className="h-12 w-12 text-orange-500" />
        <FileCheck className="absolute -right-1 -bottom-1 h-6 w-6 rounded-full bg-orange-100 p-1 text-orange-600" />
      </div>
    ),
    className: 'bg-orange-100',
  },
  [InconsistencySource.EvidenceVsEvidence]: {
    Icon: () => (
      <div className="relative">
        <FileCheck className="h-12 w-12 text-pink-500" />
        <FileX className="absolute -right-1 -bottom-1 h-6 w-6 rounded-full bg-pink-100 p-1 text-pink-600" />
      </div>
    ),
    className: 'bg-pink-100',
  },
};

export const InconsistencyTypeIcons: Record<InconsistencyType, IconConfig> = {
  [InconsistencyType.Dates]: {
    Icon: () => <Calendar className="h-12 w-12 text-purple-500" />,
    className: 'bg-purple-100',
  },
  [InconsistencyType.Events]: {
    Icon: () => <MapPin className="h-12 w-12 text-blue-500" />,
    className: 'bg-blue-100',
  },
  [InconsistencyType.Evolving]: {
    Icon: () => <RefreshCw className="h-12 w-12 text-green-500" />,
    className: 'bg-green-100',
  },
  [InconsistencyType.Details]: {
    Icon: () => <FileText className="h-12 w-12 text-yellow-500" />,
    className: 'bg-yellow-100',
  },
  [InconsistencyType.Observations]: {
    Icon: () => <Eye className="h-12 w-12 text-pink-500" />,
    className: 'bg-pink-100',
  },
  [InconsistencyType.Fabrications]: {
    Icon: () => <Drama className="h-12 w-12 text-red-500" />,
    className: 'bg-red-100',
  },
};
